(() => {
  const COUNT = 'data-search-tab-count';
  const PENDING = 'data-search-tabs-pending';
  const started = (window.searchTabCounts = window.searchTabCounts || {});

  const countOf = (tab) => {
    const value = parseInt(tab?.getAttribute(COUNT), 10);
    return Number.isNaN(value) ? null : value;
  };

  const resolve = async (strip) => {
    const tabs = Array.from(strip.querySelectorAll('[data-search-tab]'));

    await Promise.all(
      tabs.map(async (tab) => {
        const url = tab.getAttribute('data-search-tab-count-url');
        if (countOf(tab) !== null || !url) return;

        if (!started[url]) {
          started[url] = fetch(url)
            .then((response) => (response.ok ? response.text() : null))
            .catch(() => null);
        }

        const count = (await started[url])?.trim();
        if (!/^\d+$/.test(count)) return;

        tab.setAttribute(COUNT, count);
        const label = tab.querySelector('.search-tabs__count');
        if (label) label.textContent = `(${count})`;
      })
    );

    const selected = strip.querySelector('.selected');
    const others = tabs.filter((tab) => tab !== selected);
    const params = Array.from(new URLSearchParams(window.location.search));
    const filtered = params.some(([key, value]) => key.startsWith('filter.') && value !== '');

    if (strip.hasAttribute(PENDING) && !filtered && countOf(selected) === 0) {
      const target = others.find((tab) => countOf(tab) > 0);

      if (target?.href) {
        window.location.replace(target.href);
        return;
      }

      if (!target) strip.remove();
    }

    others.forEach((tab) => {
      if (countOf(tab) !== 0) return;
      tab.removeAttribute('href');
      tab.classList.add('search-tabs__button--empty');
    });

    document.querySelectorAll(`[${PENDING}]`).forEach((el) => el.removeAttribute(PENDING));
  };

  const init = () => document.querySelectorAll('[data-search-tabs]').forEach(resolve);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
